import {MouseEvent} from "react";

import type {AppState} from "@stores/AppState";


interface OpenNotificationCentreParams {
    event?: MouseEvent<HTMLElement>;
    setIsOpen?: (isOpen: boolean) => void;
    targetDom?: HTMLElement;
    withOverlay?: boolean;
}

export const openNotificationCentre = (
    appState: AppState,
    {
        event,
        setIsOpen,
        targetDom,
        withOverlay = false,
    }: OpenNotificationCentreParams
) => {
    if (appState.contextMenu?.type === 'notification-centre') {
        appState.setContextMenu(null);
    } else {
        if (setIsOpen) {
            setIsOpen(true)
        }

        appState.addAdditionalContextMenu({
            clientX: event?.clientX,
            clientY: event?.clientY,
            type: 'notification-centre',
            id: 'unique',
            minWidth: 472,
            isDark: false,
            menuPlacement: 'block-end',
            menuAlignment: 'end',
            HORIZONTAL_SHIFT: 0,
            VERTICAL_SHIFT: 8,
            withPointer: false,
            getTargetBoundingBox: targetDom ? () => targetDom.getBoundingClientRect() : undefined,
            onClose: () => {
                if (setIsOpen) {
                    setIsOpen(false)
                }
            },
            withOverlay: withOverlay,
        });
    }
};